module.exports = __webpack_public_path__ + "static/media/plus-detail-icon.64ac870c.svg";